import c from 'classnames';
import { ReactNode, useEffect, useState } from 'react';
import useEventBus, { EventType, createEventBusPublisher } from '../../hooks/useEventBus';
import styles from './style.m.less';

interface Props {
    children: ReactNode;
    duration: number;
    shakeKey?: string;
    className?: string;
}

export function Shaking({ children, shakeKey, duration = 800, className }: Props) {
    const [isShaking, setIsShaking] = useState(false);

    useEventBus(EventType.Shake, incomingShakeKey => {
        if (incomingShakeKey === shakeKey) {
            setIsShaking(true);
        }
    });

    useEffect(() => {
        const handle = setTimeout(() => setIsShaking(false), duration);
        return () => clearTimeout(handle);
    }, [isShaking, duration]);

    return (
        <div
            className={c({
                [className ?? styles.shaker]: isShaking,
            })}
        >
            {children}
        </div>
    );
}

const publishShakeEvent = createEventBusPublisher(EventType.Shake);

export function useShaker(shakeKey: string): () => void {
    return () => publishShakeEvent(shakeKey);
}
